module.exports = __webpack_public_path__ + "assets/img/desc-01-d79215d4.png";